import React, { useEffect, useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import InputField from "../form/InputField";
import { Formik } from "formik";
import { addUserSchema, addUserUpdateSchema } from "../../schema/validationSchemas";
import CustomSelect from "../form/CustomSelect";
import CommonButton from "../commonButton";
import { useDispatch } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import {
  allUserList,
  reqToAddUserFromAdmin,
  updateBankUserStatus,
} from "../../redux/slice/userSlice";
import { fetchActiveStates, fetchActiveCities } from "../../redux/slice/locationSlice";
import {
  reqToGetAllBank,
  reqToGetBankBranchDetails,
} from "../../redux/slice/bankSlice";
import { useToast } from "../../context/TostContext";
import withModal from "../withModal";

const AddUserModalInner = ({
  onClose,
  cardStatus,
  currentPage,
  limit,
  isEdit,
  isView,
  userData,
}) => {
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const toast = useToast();

  const [bankOptions, setBankOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [selectedStateId, setSelectedStateId] = useState(null);
  const nameInputRef = useRef(null);

  const initialEventState = {
    name: userData?.name || "",
    email: userData?.email || "",
    bank_id: userData?.bank_id || "",
    branch_id: userData?.branch_id || "",
    city: userData?.city_id || "",
    state: userData?.state_id || "",
    designation: userData?.designation || "",
    phone: userData?.mobile_number || "",
    password: "",
  };

  useEffect(() => {
    setTimeout(() => {
      nameInputRef.current?.focus();
    }, 200);
  }, []);

  // console.log("Bank :: ,",selectedBankId);
  // Api call to fetch all the banks & state list
  useEffect(() => {
    dispatch(fetchActiveStates({ limit: 500 })).then((res) => {
      if (res?.payload?.success === true) {
        const list = res?.payload?.data?.map((item) => ({
          value: item?.id,
          label: item?.name,
        }));
        setStateList(list);
      }
    });

    if ((isEdit || isView) && userData?.state_id) {
      setSelectedStateId(userData.state_id);
    }
  }, [dispatch, isEdit, isView, userData]);

  useEffect(() => {
    dispatch(reqToGetAllBank({ is_active: true }))
      .unwrap()
      .then((res) => {
        const list = res?.data?.map((bank) => ({
          value: bank.id,
          label: bank.name,
        }));
        setBankOptions(list);
      });

    if ((isEdit || isView) && userData?.bank_id) {
      setSelectedBankId(userData.bank_id);
    }
  }, [dispatch, isEdit, isView, userData]);

  //
  // Api call to fetch branch & city list based on selected Bank and state
  useEffect(() => {
    if (!selectedBankId) return;

    dispatch(
      reqToGetBankBranchDetails({
        id: selectedBankId,
        search: "",
        limit: 50,
        page: 1,
        is_active: true
      })
    )
      .unwrap()
      .then((res) => {
        const list = res?.data?.map((item) => ({
          value: item.id,
          label: `${item.name} - (${item.city})`,
        }));
        setBranchOptions(list);
      });
  }, [dispatch, selectedBankId]);

  useEffect(() => {
    if (!selectedStateId) return;

    dispatch(fetchActiveCities({ state_ids: selectedStateId, limit: 500 }))
      .unwrap()
      .then((res) => {
        if (res?.success) {
          const list = res?.data?.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setCityList(list);
        }
      });
  }, [dispatch, selectedStateId]);

  // Add User Final Handler
  const handleSubmit = async (values, { setSubmitting }) => {
    const data = {
      name: values?.name,
      designation: values?.designation,
      bank_id: values.bank_id,
      branch_id: values.branch_id,
      state_id: values?.state,
      email: values?.email,
      city_id: values.city,
      mobile_number: values?.phone,
      ...(values.password ? { password: values.password } : {}),
    };
    // setLoading(true);
    try {
      setSubmitting(true);
      let result;
      if (isEdit) {
        result = await dispatch(
          updateBankUserStatus({ id: userData.id, ...data })
        ).unwrap();
      } else {
        result = await dispatch(reqToAddUserFromAdmin({ data })).unwrap();
      }
      console.log("RESULSSS", result);
      if (result?.success === true) {
        toast.success(
          isEdit ? "User Updated Successfully!" : "User Added Successfully!",
        );

        onClose();
        setSubmitting(false);
        dispatch(
          allUserList({
            status: cardStatus,
            page: currentPage,
            limit: limit?.value,
          })
        ).then((res) => {
          setLoading(false);
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to Add Properties!");
    } finally {
      setSubmitting(false);
    }
  };
  const handleNumericInput = (e, setFieldValue, fieldName) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9.]/g, "");
    const parts = numericValue.split(".");
    const sanitizedValue =
      parts.length > 2
        ? `${parts[0]}.${parts.slice(1).join("")}`
        : numericValue;

    setFieldValue(fieldName, sanitizedValue);
  };

  return (


    <Formik
      initialValues={initialEventState}
      validationSchema={isEdit ? addUserUpdateSchema : addUserSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({
        errors,
        touched,
        isSubmitting,
        handleChange,
        values,
        setFieldValue,
        handleSubmit,
      }) => (
        <>
          {/* {console.log("values",values)} */}
          <Form onSubmit={handleSubmit}>
            <Modal.Body className="grid gap-3">
              <InputField
                className="g-col-6"
                label={{ name: "Name" }}
                ref={nameInputRef}
                input={{
                  id: "name",
                  name: "name",
                  type: "text",
                  placeholder: "John Doe",
                  value: values.name,
                  onChange: handleChange,
                  disabled: isView,
                }}
                validation={{
                  isInvalid: touched.name && errors.name,
                  message: errors.name,
                }}
              />
              <InputField
                className="g-col-6"
                label={{ name: "Designation" }}
                input={{
                  id: "designation",
                  name: "designation",
                  type: "text",
                  placeholder: "Manager",
                  value: values.designation,
                  onChange: handleChange,
                  disabled: isView,
                }}
                validation={{
                  isInvalid: touched.designation && errors.designation,
                  message: errors.designation,
                }}
              />
              <CustomSelect
                label={{ name: "Bank Name" }}
                name="bank_id"
                value={values.bank_id}
                onChange={(selectedOption) => {
                  setFieldValue("bank_id", selectedOption ? selectedOption.value : "");
                  setSelectedBankId(selectedOption ? selectedOption.value : ""); // 🔥 triggers branch API
                  setFieldValue("branch_id", ""); // reset branch
                  setBranchOptions([]);
                }}
                options={bankOptions}
                placeholder="Select a Bank"
                validation={{
                  isInvalid: touched?.bank_id && errors?.bank_id,
                  message: errors?.bank_id,
                }}
                isDisabled={isView}
                className="g-col-12"
              />
              <CustomSelect
                label={{ name: "Branch Name" }}
                name="branch_id"
                value={values.branch_id}
                onChange={(selectedOption) => {
                  setFieldValue("branch_id", selectedOption ? selectedOption.value : "");
                }}
                options={branchOptions}
                placeholder="Select a Branch"
                validation={{
                  isInvalid: touched?.branch_id && errors?.branch_id,
                  message: errors?.branch_id,
                }}
                isDisabled={isView || !selectedBankId}
                className="g-col-6"
              />
              <CustomSelect
                label={{ name: "State" }}
                name="state"
                value={values.state}
                onChange={(selectedOption) => {
                  setFieldValue("state", selectedOption ? selectedOption.value : "");
                  setSelectedStateId(selectedOption ? selectedOption.value : "");
                }}
                options={stateList}
                placeholder="Select a State"
                validation={{
                  isInvalid: touched?.state && errors?.state,
                  message: errors?.state,
                }}
                isDisabled={isView}
                className="g-col-6"
              />
              <InputField
                className="g-col-6"
                label={{ name: "Email" }}
                input={{
                  id: "email",
                  name: "email",
                  type: "email",
                  placeholder: "rohit@gmail.com",
                  value: values.email,
                  onChange: handleChange,
                  disabled: isView,
                }}
                validation={{
                  isInvalid: touched.email && errors.email,
                  message: errors.email,
                }}
              />
              <CustomSelect
                label={{ name: "City" }}
                name="city"
                value={values.city}
                onChange={(selectedOption) => {
                  setFieldValue("city", selectedOption ? selectedOption.value : "");
                }}
                options={cityList}
                placeholder="Select a City"
                validation={{
                  isInvalid: touched?.city && errors?.city,
                  message: errors?.city,
                }}
                isDisabled={isView || !selectedStateId}
                className="g-col-6"
              />
              <InputField
                className="g-col-6"
                label={{ name: "Mobile Number" }}
                input={{
                  id: "phone",
                  name: "phone",
                  type: "text",
                  placeholder: "9876543210",
                  value: values.phone,
                  onChange: (e) => handleNumericInput(e, setFieldValue, "phone"),
                  disabled: isView,
                }}
                validation={{
                  isInvalid: touched.phone && errors.phone,
                  message: errors.phone,
                }}
              />

              {!isEdit && !isView && (
                <InputField
                  className="g-col-12"
                  label={{ name: "Password" }}
                  input={{
                    id: "password",
                    name: "password",
                    type: "password",
                    placeholder: "Enter your password",
                    value: values.password,
                    onChange: handleChange,
                  }}
                  validation={{
                    isInvalid: touched.password && errors.password,
                    message: errors.password,
                  }}
                />
              )}
            </Modal.Body>
            {!isView && (
              <Modal.Footer>
                <CommonButton
                  title={isEdit ? "Update User" : "Add User"}
                  type="submit"
                  disabled={isSubmitting}
                />
              </Modal.Footer>
            )}

          </Form>
        </>
      )}
    </Formik>


  );
};

const AddUserModal = withModal(AddUserModalInner);
export default AddUserModal;
